import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IdelinkModuleTheme } from '../../configs/IdeLinkTheme';
import { NavbarModuleItem } from '../../../libs/IdeLink.Web.Common/src/components/NavBar/components/NavBarItem/NavBarItem';
import { RouteItem } from '../../../libs/IdeLink.Web.Common/src/types/RouteItem';
import { PrivateRoute } from '../../routes/PrivateRoute';
import { PermissionsActions } from '../../services/permissions/PermissionsActions';
import { SectorCreatePageLoading } from './Pages/SectorCreatePage/SectorCreatePageLoading';
import { SectorDetailsPageLoading } from './Pages/SectorDetailsPage/SectorDetailsPageLoading';
import { SectorListPageLoading } from './Pages/SectorListPage/SectorListPageLoading';
import { SectorsPermissions } from './Services/SectorsPermissions';

export class SectorsModule {
    public static SECTOR_LIST: string = '/sectors';
    public static SECTOR_CREATE: string = '/sectors/create';
    public static SECTOR_DETAILS: string = '/sectors/:id';

    private static getSectorListRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: SectorsModule.SECTOR_LIST,
            component: SectorListPageLoading,
            hasAccess: () => SectorsPermissions.Admin.canList,
        },
    });
    private static getSectorCreateRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: SectorsModule.SECTOR_CREATE,
            component: SectorCreatePageLoading,
            hasAccess: () => SectorsPermissions.Admin.canCreate,
        },
    });
    private static getSectorDetailsRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: SectorsModule.SECTOR_DETAILS,
            component: SectorDetailsPageLoading,
            hasAccess: () => SectorsPermissions.Admin.canRead,
        },
    });

    public static sectorDetailsRoute = (sectorId: string): string => {
        return `${SectorsModule.SECTOR_DETAILS}`.replace(':id', sectorId);
    };

    public static getSectorsRoutes = (): Array<RouteItem> => {
        return [
            SectorsModule.getSectorListRoute(),
            SectorsModule.getSectorCreateRoute(),
            SectorsModule.getSectorDetailsRoute(),
        ];
    };

    public static preloadSectors = () => {
        SectorListPageLoading.preload();
        SectorCreatePageLoading.preload();
        SectorDetailsPageLoading.preload();
    };

    public static getSectorsModuleNavbar = (sectorsTheme: IdelinkModuleTheme): NavbarModuleItem => {
        return {
            icon: sectorsTheme.navbarIcon,
            label: <FormattedMessage id="navbar.sectors" />,
            route: SectorsModule.SECTOR_LIST,
            onMouseOver: () => SectorsModule.preloadSectors(),
            disabled: !SectorsPermissions.Admin.canRead,
            hide: PermissionsActions.shouldHideAdminSection(),
        };
    };
}
